import { Space } from 'antd';

import EmailEditorFontSetting from './EmailEditorFontSetting';

const EmailEditorContentSettings = () => {
  return (
    <Space direction='horizontal' size={0}>
      <EmailEditorFontSetting />
    </Space>
  );
};

export default EmailEditorContentSettings;
